import { useEffect } from 'react';

const nestedOverlay = '[role="dialog"]:not(.portal-expandable-report), .p-sidebar-visible, .p-dropdown-panel, .p-multiselect-panel';

export default function useReportOverlay(expanded, restore, card, trigger) {
    useEffect(() => {
        if (!expanded) return;
        const node = card.current;
        const triggerNode = trigger.current;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        // Disable the underlying page without hiding it or moving the live report.
        const background = [];
        let ancestor = node;
        while (ancestor && ancestor !== document.body) {
            for (const sibling of Array.from(ancestor.parentElement?.children || [])) {
                if (sibling === ancestor || sibling.matches('.portal-report-backdrop, script, style, link')) continue;
                background.push([sibling, sibling.inert]);
                sibling.inert = true;
            }
            ancestor = ancestor.parentElement;
        }
        triggerNode?.focus({ preventScroll: true });
        const onKeyDown = (event) => {
            if (event.defaultPrevented || document.querySelector(nestedOverlay)) return;
            if (event.key === 'Escape') { event.preventDefault(); restore(); }
            if (event.key !== 'Tab') return;
            const focusable = Array.from(node.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], [tabindex="0"]'))
                .filter((element) => element.getClientRects().length > 0);
            const first = focusable[0], last = focusable[focusable.length - 1];
            if (event.shiftKey && (document.activeElement === first || !node.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
            if (!event.shiftKey && (document.activeElement === last || !node.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
            background.forEach(([element, inert]) => { element.inert = inert; });
            document.body.style.overflow = previousOverflow;
            if (node?.isConnected) triggerNode?.focus({ preventScroll: true });
        };
    }, [expanded, restore, card, trigger]);
}
